import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { LeadService } from '../leads/leadService';
import { AccountService } from '../accounts/accountService'
import { AccountUserService } from '../service/account.service';
import { GelAllContactRequestModel } from './model/contacts-request.model';
import { HttpService } from '../modules/shared/services/http.service';
import { TypeGroupIds } from '../modules/shared/constants/category-groupid.constants';
@Injectable({ providedIn: 'root' })
export class ContactService {

    contactURL = ""
    contactURLContact = "";
    coreUrl = ""
    localAppUrl = "";
    contactUrl = "";
    apiUrlAccount = "";
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    user: any;
    constructor(
        private httpService: HttpService,
        private http: HttpClient,
        private accountService:AccountService,
        private leadService: LeadService,
        private accountUserService: AccountUserService) {
            this.accountUserService.user.subscribe(x => this.user = x);
        //this.appUrl = environment.apiUrl + "Contact/";
        this.contactURL = environment.contactURL;
        this.contactURLContact = environment.contactURL + "Contact/";
        this.coreUrl = environment.coreUrl;
        this.localAppUrl = environment.localApiUrl;
        this.apiUrlAccount = environment.apiUrlAccount;
    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    updateUser(user) {
        return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    // getAllContacts() {
    //     return this.http.get<any>(this.localAppUrl + 'allContacts')
    //         .toPromise()
    //         .then(res => res);
    // }

    getAllContacts(pageSize: number, pageNumber: number, companyID: number, userId:number,  options?, objectNameList?) {
        // let url = this.appUrl + "?organizationId=" + companyID
        // + "&userId=" + userId
        // + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize
        // + "&objectNameList=status&objectNameList=gender&objectNameList=contactType&objectNameList=contactAssociationType&objectNameList=relationshipStatus&objectNameList=source&objectNameList=maritalStatus&objectNameList=annualIncome&objectNameList=degree&objectNameList=fieldOfStudy&objectNameList=reportsTo&objectNameList=assistant&objectNameList=contactEmails&objectNameList=contactPhones&objectNameList=contactSocialProfiles&objectNameList=contactAddresses&objectNameList=contactSpokenLanguages";

        let url = `${this.contactURLContact}?organizationId=${companyID}&pageNumber=${pageNumber}&pageSize=${pageSize}${objectNameList}&isActive=${options.isActive}`
        if(options){
            if(options.sort){
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }

            if(options.contactAssociationTypeId){
                url = `${url}&contactAssociationTypeId=${options.contactAssociationTypeId}`;
            }
            if(options.filter && options.filter.field){
                url = `${url}&SearchValue=${encodeURIComponent(options.filter.value)}&SearchColumns=${options.filter.field}`;
            }
            if(options.recentFilters){
                url = `${url}&filters=${options.recentFilters}`;
            }
        }
        // default sorting
        if(!options || !options.sort){
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        return this.http.get<any>(url, { observe: 'response'})
        .toPromise()
        .then(res =>

         ({
                contacts: res.body,
                headers : JSON.parse(res.headers.get('X-Pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            })

         );

    }

    addContact(c) {
        return this.http.post<any>(this.contactURLContact, c)
            .toPromise()
            .then(res => res);
    }
    // addContact(c) {
    //     return this.http.post<any>(this.localAppUrl + 'allContacts/', c)
    //         .toPromise()
    //         .then(res => res);
    // }

    getContactById(contactId,associationTypeId) {
        let url =`${this.contactURLContact}AssociationType/${associationTypeId||0}/Contact/${contactId}`;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }

    updateContact(contact) {
        return this.http.put<any>(this.contactURLContact, contact)
            .toPromise()
            .then(res => res);
    }

    deleteContact(id,associationTypeId) {
        return this.http.delete<any>(`${this.contactURLContact}AssociationType/${associationTypeId}/Contact/${id}`)
            .toPromise()
            .then(res => res);
    }

    deleteContactRelationship(childAccountId: number, contactId: number) {
        return this.http.delete<any>(`${this.apiUrlAccount}v2/AccountContactParentChildRelation/ChildAccount/${childAccountId}/ParentContact/${contactId}`)
            .toPromise()
            .then(res => res);
    }

    checkClearBitData(email) {
        return this.http.get<any>(environment.clearBitAPIURL + email, {
            headers: new HttpHeaders({
                "Authorization": environment.clearBitAPIKey
            })
        })
            .toPromise()
            .then(res => res)
    }

    // getAllStages(companyID: number) {
    //     return this.http.get<any>(environment.apiUrl + 'ContactStage', {
    //         params: new HttpParams().append("companyId", companyID.toString())
    //     })
    //         .toPromise()
    //         .then(res => res);
    // }
    getAllStages() {
        return this.http.get<any>(this.localAppUrl + 'ContactStages/')
            .toPromise()
            .then(res => res);
    }

    getAllCountries() {
        return this.http.get<any>(environment.apiUrl + 'Country/CountryMinified')
            .toPromise()
            .then(res => res);
    }
    getAllCities(stateId: number) {
        return this.http.get<any>(environment.apiUrl + 'City', {
            params: new HttpParams().append("stateId", stateId.toString())
        })
            .toPromise()
            .then(res => res);
    }
    getAllAsyncCities(stateId: number) {
        return this.http.get<any>(environment.apiUrl + 'City', {
            params: new HttpParams().append("stateId", stateId.toString())
        })
            .toPromise();
    }
    getAllStates(countryId: number) {
        return this.http.get<any>(environment.apiUrl + 'State', {
            params: new HttpParams().append("countryId", countryId.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllAsyncStates(countryId: number) {
        return this.http.get<any>(environment.apiUrl + 'State', {
            params: new HttpParams().append("countryId", countryId.toString())
        })
            .toPromise();
    }

    getAllSocialProfiles(socialProfileType) {
        return this.http.get<any>(this.apiUrlAccount + 'Type?groupId=' + socialProfileType)
            .toPromise()
            .then(res => res);
    }

    getAllPhoneTypes(phoneType) {
        return this.http.get<any>(this.apiUrlAccount + 'Type?groupId=' + phoneType)
            .toPromise()
            .then(res => res);
    }

    getAllEmailTypes() {
        return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType')
            .toPromise()
            .then(res => res);
    }

    // getAllGender() {
    //     return this.http.get<any>(environment.apiUrl + 'Gender')
    //         .toPromise()
    //         .then(res => res);
    // }

    getAllGender() {
        return this.http.get<any>(this.coreUrl + 'Gender/GenderMinified')
            .toPromise()
            .then(res => res);
    }

    getGenders() {
        return this.http.get<any>(this.coreUrl + 'Gender')
            .toPromise()
            .then(res => res);
    }

    getAllLanguage() {
        return this.http.get<any>(this.coreUrl + 'Language/LanguageMinified')
            .toPromise()
            .then(res => res);
    }

    getLanguages() {
        return this.http.get<any>(this.coreUrl + 'Language')
            .toPromise()
            .then(res => res);
    }

    getAllContactTypes() {
        return this.http.get<any>(`${this.coreUrl}Type?groupId=${TypeGroupIds.ContactType}`)
            .toPromise()
            .then(res => res);
    }

    getAllContactTypesNew(): Observable<any>{
        return this.http.get<any>(`${environment.contactURL}Contact/PermittedContactTypeCount`)
    }

    getAllContactType(): Observable<any>{
        return this.http.get<any>(`${environment.contactURL}Contact/ContactType`)
    }

    getAllContactTypesNewWithPermission(query = {}): Observable<any> {
        let params = new HttpParams();
        for (const [key, value] of Object.entries(query)) {
            params = params.append(key, value as any);
        }
        return this.http.get<any>(`${environment.contactURL}Contact/PermittedContactTypeCount`, { params })
    }

    deleteContactType(id): Observable<any>{
        return this.http.delete<any>(`${environment.contactURL}Contact/DeleteContactType?id=${id}`)
    }

    addEditContactType(data): Observable<any>{
        return this.http.post<any>(`${environment.contactURL}Contact/AddEditContactType`, data)
    }

    // addContactType(data): Observable<any>{
    //     return this.http.post<any>(`${environment.contactURL}AddContactType`, data)
    // }

    makeContatTypeDefault(data): Observable<any>{
        return this.http.post<any>(`${environment.contactURL}Contact/MakeDefault`, data)
    }

    getContactTypes() {
        return this.http.get<any>(`${this.coreUrl}Type?groupId=${TypeGroupIds.ContactType}`)
            .toPromise()
            .then(res => res);
    }

    getSalutations() {
        return this.http.get<any>(this.contactURL + 'Salutation/SalutationMinified')
    }

    getAllContactAssociation() {
        return this.http.get<any>(this.contactURL + 'ContactAssociationType/')
            .toPromise()
            .then(res => res);
    }

    getAllRelationshipStatus() {
        return this.http.get<any>(this.coreUrl + 'RelationshipStatus/RelationshipStatusMinified')
            .toPromise()
            .then(res => res);
    }

    getRelationshipStatuses() {
        return this.http.get<any>(this.coreUrl + 'RelationshipStatus')
            .toPromise()
            .then(res => res);
    }

    getAllMaritalStatus() {
        return this.http.get<any>(this.coreUrl + 'MaritalStatus/MaritalStatusMinified')
            .toPromise()
            .then(res => res);
    }

    getAllMaritalStatuses() {
        return this.http.get<any>(this.coreUrl + 'MaritalStatus')
            .toPromise()
            .then(res => res);
    }

    getAllContactSource() {
        return this.http.get<any>(this.coreUrl + 'Source/SourceMinified')
            .toPromise()
            .then(res => res);
    }

    getAllSources(organizationId: number) {
        return this.http.get<any>(this.coreUrl + 'Source?organizationId=' + organizationId)
            .toPromise()
            .then(res => res);
    }

    getAllAnnualIncome() {
        return this.http.get<any>(this.coreUrl + 'AnnualIncome/AnnualIncomeMinified')
            .toPromise()
            .then(res => res);
    }

    getAnnualIncomes() {
        return this.http.get<any>(this.coreUrl + 'AnnualIncome')
            .toPromise()
            .then(res => res);
    }

    getAllDegree() {
        return this.http.get<any>(this.coreUrl + 'Degree/DegreeMinified')
            .toPromise()
            .then(res => res);
    }

    getDegrees() {
        return this.http.get<any>(this.coreUrl + 'Degree')
            .toPromise()
            .then(res => res);
    }

    getAllStudyField() {
        return this.http.get<any>(this.coreUrl + 'FieldOfStudy/FieldOfStudyMinified')
            .toPromise()
            .then(res => res);
    }

    getStudyFields() {
        return this.http.get<any>(this.coreUrl + 'FieldOfStudy')
            .toPromise()
            .then(res => res);
    }

    getAllReportsTo() {
        return this.http.get<any>(this.localAppUrl + 'ReportsTo/')
            .toPromise()
            .then(res => res);
    }

    getAllAssistant() {
        return this.http.get<any>(this.localAppUrl + 'Assistant/')
            .toPromise()
            .then(res => res);
    }

    getContactStagesAndCount(organizationId:number, userId:number): Observable<any>{
        return this.http.get<any>(this.contactURL + 'Contact/Count', {
            headers: new HttpHeaders({
                "organizationId": `${organizationId}`,
                "userId": `${userId}`,
            })
        })
    }

    getAllContactOfOrganization({organizationId, userId}){
        return this.http.get<any>(`${this.contactURL}Contact/ContactsWithName`, {
            headers: new HttpHeaders({
                "organizationId": `${organizationId}`,
                "userId": `${userId}`,
            })
        })
    }

    getContactsWithName(data) {
        let url = this.contactURL + 'Contact/ContactsWithName';
        if(data && data['search']){url = url + '?search=' + encodeURIComponent(data['search']);}
        return this.http.get<any>(url)
          .toPromise()
          .then(res => res);
    }

    async getContactsValues(associationName, orgContacts){
        let reports = []
        if(associationName.name == "Lead"){

            const res = await this.leadService.getLeadById(associationName.id);
            reports = res && res.leadContacts ? res.leadContacts.map((el) => el.contact): [];
            return of(reports);

          } else if (associationName.name == "Account"){
            const res = await this.accountService.getAccountContacts(associationName.id);
            reports = res && res.accountContacts? res.accountContacts.map((el) => el.contact): [];
            return of(reports);

          } else if (associationName.name == "Organization"){
            return of(orgContacts)
          }
    }

    uploadContacts({ OrganizationId, CreatedSource, UserId, file }) {
        const formData = new FormData();
        formData.append('filesData', file);
        const url = `${this.contactURLContact}import?organizationId=${OrganizationId}&CreatedSource=${CreatedSource}&UserId=${UserId}`;
        return this.http.post(url, formData, { responseType: 'text' }).toPromise();
    }

    importFields() {
        const url = `${this.contactURLContact}Fields`;
        return this.http.get(url);
    }

    getContactConfigurations(){
        return this.http.get<any>( `${environment.configUrl}Configuration/ConfigurationsByModuleName?name=Contact`)
    }

    getStatusCommentsForActiveInactive(id) {
        return this.http.get<any>(`${this.contactUrl}Contact/StatusAudit?id=${id}`)
        .toPromise()
        .then(res => res);
    }

    activeInactiveContact(data){
        let url = `${this.contactURL}Contact/ChangeActiveInactiveStatus`;
        return this.http.put(url, data)
          .toPromise()
          .then(res => res);
    }

    getActiveInactiveDataByName(name) {
        return this.http.get<any>(`${this.contactURL}Group/Name?name=` + name);
    }

    getActiveInactiveReasons(groupId) {
        return this.http.get<any>(`${this.coreUrl}Category/GetAllCategoryOrganizationWise?groupId=` + groupId);
    }

    addActiveInactiveReason(data) {
        return this.http.post<any>(`${this.coreUrl}Category`, data);
    }

    updateActiveInactiveReason(data) {
        return this.http.put<any>(`${this.coreUrl}Category`, data);
    }

    deleteActiveInactiveReason(id) {
        return this.http.delete<any>(`${this.coreUrl}Category/${id}`);
    }

    getContactByAssociation(associationNameId){
        const associationTypeName = 'Organization';
        return this.http.get<any>(`${environment.contactURL}Contact/GetContactsByAssociation?associationTypeName=${associationTypeName}&associationNameId=${associationNameId}`);
    }

    getContactCount(filter: string, isActive: boolean,globalChannelId:number){
        return this.httpService.post(`${environment.contactURL}Contact/Count`, {
            filter: filter,
            isActive: isActive,
            globalChannelId: globalChannelId
        });
    }

    getContactList(requestModel: GelAllContactRequestModel){
        return this.httpService.post(`${environment.contactURL}Contact/GetPagedList`, requestModel);
    }

    getContactListNew(requestModel: GelAllContactRequestModel){
        return this.httpService.post(`${environment.contactURL}Contact/GetPermittedPagedList`, requestModel);
    }

    contactEmailValidation(emailAddress: string, contactAssociationTypeId: number, contactId: number = 0){
        let params = new HttpParams();
        params = params.append('emailAddress', emailAddress);
        params = params.append('contactAssociationTypeId', contactAssociationTypeId);
        params = params.append('contactId', contactId||0);

        return this.http.get(`${this.contactURL}Contact/ValidateEmail`,{ params });
    }

}
